import { Rocket } from 'lucide-preact'
import { memo } from 'preact/compat'
import { DashboardStatTile } from './DashboardStatTile'

interface ActiveCampaignsStatTileProps {
  count: number | null | undefined
  rangeLabel?: string
  loading?: boolean
  error?: string | null
  failed?: boolean
}

export const ActiveCampaignsStatTile = memo((props: ActiveCampaignsStatTileProps) => (
  <DashboardStatTile
    titleLines={['Live', 'Campaigns']}
    icon={<Rocket className="w-5 h-5 text-primary-600 dark:text-primary-400" />}
    badge="Active"
    badgeTitle="Active campaigns currently running"
    {...props}
  />
))
